export function createSignupURL({
	type,
	email,
	nickname,
	code,
}: {
	type: string;
	email?: string;
	nickname?: string;
	code: string;
}) {
	return `/onboarding/signup?type=${type}${email ? `&email=${email}` : ''}${nickname ? `&nickname=${nickname}` : ''}&code=${code}`;
}
